// this is only a proxy for main_app's entrypoint
require('../../../../app/packs/entrypoints/application')
